import axios from "axios";
export default async function importXML() {
  let inlays = {};

  let xml2js = require("xml2js"),
    parser = new xml2js.Parser({ explicitArray: false, mergeAttrs: true });
  let parsed_inlays = await axios
    .all([
      axios.get(process.env.BASE_URL + "xml/LCN-GT2T.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT2 2+2 2013.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT2 1+2 2013.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT6 2+2 2013.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT6 1,2+2 2013.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT6 1,2+2.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT6 1,3 2013.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT6 6+2 2013.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT6 3,1 2013.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT6 1+2 2013.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT8.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT8 1,4+2.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT8 2,2+4.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT12 12+8 2013.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT12 1,8+6 2013.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT12 2,4+4 2013.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT12 3+2 2013.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT12 8,1+6 2013.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT12 6+2 2013.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT12 2,1+2 2013.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT12 (2013) 4,1+2.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT10D 1+1+1,1+1+1 2013.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-MT4 1,4.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-MT4 1,2.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-MT4 2,4.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-MT4 2,2.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT6L_111.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT6L_112.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT6L_121.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT6L_122.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT6L_211.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT6L_212.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT6L_221.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT6L_222.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT6 6+2.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT2 1+2.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT2 2+2.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT12 12+8.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT12 (2013) 1,8,1+6.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT12 2,4+4.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT12 1,8+6.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT12 2,4+4.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT12 8,1+6.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT12 6+2.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT12 2,1+2.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT10D 1+1+1,1+1+1.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GSA4.xml"),
    ])
    .then((response) => {
      let regex = /^.*\/LCN-(.*)\..*$/;
      for (let gt in response) {
        //get the name of the GT so we can identify them later
        let gtName = response[gt].config.url.match(regex)[1].toLowerCase();
        parser.parseString(response[gt].data, function (err, result) {
          //Hilfsvariable zum Verkürzen
          let layout = "";
          if (!Array.isArray(result.KeyboardMapping.Layout.Parts.Part)) {
            layout = result.KeyboardMapping.Layout.Parts.Part;
          } else {
            for (let i in result.KeyboardMapping.Layout.Parts.Part) {
              if (result.KeyboardMapping.Layout.Parts.Part[i].name == "Main") {
                layout = result.KeyboardMapping.Layout.Parts.Part[i];
              }
            }
          }
          //group GTs
          let gtGrp = "";
          if (gtName.indexOf(" ") > 0) {
            gtGrp = gtName.substring(0, gtName.indexOf(" "));
          } else if (gtName.indexOf("_") > 0) {
            gtGrp = gtName.substring(0, gtName.indexOf("_"));
          } else {
            gtGrp = gtName;
          }
          //if group doesnt exist yet add it
          if (!inlays[gtGrp]) {
            inlays[gtGrp] = [];
          }
          let gt = {};
          //Add inlay and it's values to the group
          gt.name = gtName;
          gt["project-name"] = gtName;
          gt.group = gtGrp;
          gt.gtDim = {};
          gt.gtBackground = "white";
          if (gtGrp == "gt6l") {
            gt.gtDim.width = 201;
          } else {
            gt.gtDim.width = 340.15;
          }
          //section for the dimensions of the GTs to replace the imgs in the old GT-Designer
          if (
            gtGrp == "gt2t" ||
            gtGrp == "gt6" ||
            gtGrp == "gt8" ||
            gtGrp == "gt2" ||
            gtGrp == "gsa4"
          ) {
            gt.gtDim.topHeight = 56;
            gt.gtDim.botHeight = 56;
            gt.gtDim.height = 340;
            gt.gtDim.rWidth = 56;
            gt.gtDim.lWidth = 60;
          } else if (gtGrp == "gt12") {
            gt.gtDim.topHeight = 53;
            gt.gtDim.botHeight = 56;
            gt.gtDim.height = 605;
            gt.gtDim.rWidth = 53;
            gt.gtDim.lWidth = 56;
          } else if (gtGrp == "gt10d") {
            gt.gtDim.topHeight = 330;
            gt.gtDim.botHeight = 56;
            gt.gtDim.height = 605;
            gt.gtDim.rWidth = 55;
            gt.gtDim.lWidth = 58;
          } else if (gtGrp == "mt4") {
            gt.gtDim.topHeight = 72;
            gt.gtDim.botHeight = 67;
            gt.gtDim.height = 340;
            gt.gtDim.rWidth = 67;
            gt.gtDim.lWidth = 70;
          } else if (gtGrp == "gt6l") {
            gt.gtDim.topHeight = 56;
            gt.gtDim.botHeight = 56;
            gt.gtDim.height = 1123;
            gt.gtDim.rWidth = 43;
            gt.gtDim.lWidth = 43;
          } else if (gtGrp == "gsa4") {
            gt.gtDim.topHeight = 56;
            gt.gtDim.botHeight = 45;
            gt.gtDim.height = 340;
            gt.gtDim.rWidth = 45;
            gt.gtDim.lWidth = 60;
          }
          if (gt.name.includes("gt6l")) {
            let gt6l_inlays = [],
              counter = 1;
            layout.Keys.Key.map((key) => {
              if (key.Shapes.Rect.length > 2) {
                gt6l_inlays.push({
                  type: "single",
                });
              } else {
                if (counter % 2 !== 0) {
                  gt6l_inlays.push({
                    type: "double",
                  });
                }
                counter++;
              }
            });
            gt.inlay = gt6l_inlays;
            gt.preview = populateGT(layout);
          } else {
            gt.inlay = populateGT(layout);
          }

          //add parsed Inlay to its group
          inlays[gtGrp].push(gt);
        });
      }
      return inlays;
    })
    .then((inlays) => {
      getGT6Lindividual().then((response) => {
        let gt6l_inlays = [];
        let index = 0;
        for (let gt6l in inlays["gt6l"]) {
          inlays.gt6l[gt6l].inlay.map((inlay) => {
            if (inlay.type == "single") {
              // let adjusted = adjustPos(inlay.top, single);

              gt6l_inlays.push(response[0]);
            } else {
              gt6l_inlays.push(response[1]);
            }
            index++;
          });
          inlays.gt6l[gt6l].inlay = gt6l_inlays;
          gt6l_inlays = [];
        }
      });
      //console.log(inlays);
      return inlays;
    });

  return inlays;
}

//This function turns the parsed layout into workable Javascript Objects and returns it
function populateGT(layout) {
  let keys = [];
  let inlay = {};
  inlay.showLEDs = false;
  inlay.draggableTexts = [];
  inlay.style = {};
  inlay.btns = [];
  inlay.leds = [];
  inlay.bargraph = [];

  //Sometimes the Info is in an Array of Objects, sometimes not
  if (!Array.isArray(layout.Shapes.Rect)) {
    inlay.style.top =
      parseFloat(layout.Shapes.Rect.top) - parseFloat(layout.topOffset) + "mm";
    inlay.style.left =
      parseFloat(layout.Shapes.Rect.left) -
      parseFloat(layout.leftOffset) +
      "mm";
    inlay.style.height =
      parseFloat(layout.Shapes.Rect.bottom) -
      parseFloat(layout.Shapes.Rect.top) +
      "mm";
    inlay.style.width =
      parseFloat(layout.Shapes.Rect.right) -
      parseFloat(layout.Shapes.Rect.left) +
      "mm";
  } else {
    inlay.style.top =
      parseFloat(layout.Shapes.Rect[0].top) -
      parseFloat(layout.topOffset) +
      "mm";
    inlay.style.left =
      parseFloat(layout.Shapes.Rect[0].left) -
      parseFloat(layout.leftOffset) +
      "mm";
    inlay.style.height =
      parseFloat(layout.Shapes.Rect[0].bottom) -
      parseFloat(layout.Shapes.Rect[0].top) +
      "mm";
    inlay.style.width =
      parseFloat(layout.Shapes.Rect[0].right) -
      parseFloat(layout.Shapes.Rect[0].left) +
      "mm";
  }

  //Get the Location of the keys Array
  if (Array.isArray(layout.Keys.Key)) {
    for (let i in layout.Keys.Key) {
      keys.push(layout.Keys.Key[i].Shapes.Rect);
    }
  } else {
    keys.push(layout.Keys.Key.Shapes.Rect);
  }
  inlay.style.background = "";
  inlay.style["background-color"] = "#ffffff";
  inlay.style["background-image"] = "";
  inlay.style["background-size"] = "100%";
  inlay.style["background-position"] = "";
  inlay.showImg = false;
  inlay.selectedText = [];
  inlay.ledRad = 0 + "px";
  inlay.style.horizontal = false;

  //Check if Inlay has a Bargraph and if so add the Bargraph to the bargraph-Array
  if (Array.isArray(layout.Shapes.Rect)) {
    inlay.showBargraph = false;
    inlay.showBargraphCaptions = false;
    inlay.bargraphCaptionsAlternating = true;
    inlay.selectedBarGType = "BargraphLED";
    let caption = 28;
    layout.Shapes.Rect.forEach((bargraph, index) => {
      //add captions
      if (bargraph.type.includes("Bar")) {
        if (
          bargraph.type != layout.Shapes.Rect[index - 1].type &&
          index - 1 > 0
        )
          caption = 28;
        inlay.bargraph.push({
          type: bargraph.type,
          id: index - 1,
          style: {
            top:
              parseFloat(bargraph.top) -
              parseFloat(layout.topOffset) +
              1.1 +
              "mm",
            left:
              parseFloat(bargraph.left - parseFloat(layout.leftOffset)) + "mm",

            width:
              parseFloat(bargraph.right) - parseFloat(bargraph.left) + "mm",
            height:
              parseFloat(bargraph.bottom) - parseFloat(bargraph.top) + "mm",
            "background-color": "white",
          },
          caption: {
            content: "" + caption,
            style: {
              left:
                parseFloat(bargraph.left) -
                parseFloat(layout.leftOffset) -
                3.1 +
                (caption % 2 == 0 ? 6 : 0) +
                "mm",
              top:
                parseFloat(bargraph.top) -
                parseFloat(layout.topOffset) +
                1.15 +
                "mm",
              color: "black",
            },
          },
        });
        caption--;
      }
    });
  }
  //Add the keys as either btns or LEDs with their positions and other values
  for (let key in keys) {
    if (Array.isArray(keys[key])) {
      // console.log(gt.name, keys[key]);
      for (let btn in keys[key]) {
        if (keys[key][btn].type == "Key") {
          inlay.btns.push({
            style: {
              top:
                parseFloat(keys[key][btn].top) -
                parseFloat(layout.topOffset) +
                1.1 +
                "mm",
              left:
                parseFloat(
                  keys[key][btn].left - parseFloat(layout.leftOffset)
                ) + "mm",

              width:
                parseFloat(keys[key][btn].right) -
                parseFloat(keys[key][btn].left) +
                "mm",
              height:
                parseFloat(keys[key][btn].bottom) -
                parseFloat(keys[key][btn].top) +
                "mm",

              border: "",
              "border-radius": "",
              "align-items": "align-items-end",
              "justify-content": "justify-content-center",
              background: "",
              "background-image": "",
              "background-size": "100%",
              image: {
                "background-image": "",
                "background-color": "",
                "background-position": "top",
                "background-size": "",
                filter: "",
              },
              gradient: {
                firstColour: "#ffffff",
                secondColour: "#ffffff",
              },
            },
            content: {
              content: "Text",
              "d-content": true,
              style: {
                "font-family": "",
                color: "",
                "font-size": "",
                "font-style": "",
                "font-weight": "",
                "text-decoration": "",
                scale: "",
                "background-position": "",
                "align-items": "align-items-end",
                "justify-content": "justify-content-center",
              },
            },
            draggable: false,
          });
          //add the LEDs to the LED-Array
        } else if (keys[key][btn].type == "LED") {
          inlay.leds.push({
            style: {
              top:
                parseFloat(keys[key][btn].top) -
                parseFloat(layout.topOffset) +
                1.1 +
                "mm",
              left:
                parseFloat(
                  keys[key][btn].left - parseFloat(layout.leftOffset)
                ) + "mm",

              width:
                parseFloat(keys[key][btn].right) -
                parseFloat(keys[key][btn].left) +
                0.5 +
                "mm",
              height:
                parseFloat(keys[key][btn].bottom) -
                parseFloat(keys[key][btn].top) +
                0.5 +
                "mm",
              display: "none",
            },
          });
        }
      }
    } else if (keys[key].type == "Key") {
      inlay.btns.push({
        style: {
          top:
            parseFloat(keys[key].top) -
            parseFloat(layout.topOffset) +
            1.1 +
            "mm",
          left:
            parseFloat(keys[key].left - parseFloat(layout.leftOffset)) + "mm",

          width:
            parseFloat(keys[key].right) - parseFloat(keys[key].left) + "mm",
          height:
            parseFloat(keys[key].bottom) - parseFloat(keys[key].top) + "mm",
          background: "",
          border: "",
          "border-radius": "",
          image: {
            "background-image": "",
            "background-color": "",
            "background-position": "top",
            "background-size": "",
            filter: "",
          },
          gradient: {
            firstColour: "#ffffff",
            secondColour: "#ffffff",
          },
        },
        content: {
          content: "Text",
          "d-content": true,
          style: {
            "font-family": "",
            "font-color": "",
            "font-size": "",
            "font-style": "",
            "font-weight": "",
            "border-bottom": "",
            scale: "",
            "background-position": "",
            "align-items": "align-items-end",
            "justify-content": "justify-content-center",
          },
        },
        draggable: false,
      });
    }
  }
  return inlay;
}

//This function gets the layouts for the individual GT6L layouts.
//This is separate so we can work them into the "big" layouts when needed
async function getGT6Lindividual() {
  let layout,
    inlays = [];
  let xml2js = require("xml2js"),
    // create new XML Parser
    parser = new xml2js.Parser({ explicitArray: false, mergeAttrs: true });
  let gt6l_indiv = await axios
    .all([
      axios.get(process.env.BASE_URL + "xml/LCN-GT6L_HSZ_Einzeltaste.xml"),
      axios.get(process.env.BASE_URL + "xml/LCN-GT6L_HSZ_Doppeltaste.xml"),
    ])
    .then((response) => {
      for (let gt6l in response) {
        parser.parseString(response[gt6l].data, function (err, result) {
          layout = result.KeyboardMapping.Layout.Parts.Part;
          inlays.push(populateGT(layout));
        });
      }
      return inlays;
    });
  return inlays;
}
